import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import { WorkshopRegistrationDetails } from '@/modals/workshop-details/workshopRegistrationDetails';
import { WorkshopTransactionDetails } from '@/modals/workshop-details/workshopTransactionDetails';
import { EventBookingDetails } from '@/modals/event-details/eventBookingDetails';
import { AesEncryptionService } from '@services/aes-encryption.service';
@Component({
  selector: 'app-workshop-details',
  templateUrl: './workshop-details.component.html',
  styleUrl: './workshop-details.component.scss'
})
export class WorkshopDetailsComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  searchText: any = "";
  getListOfWorkshopDetails: WorkshopRegistrationDetails[] = [];
  getallWorkshopDetails: WorkshopRegistrationDetails[] = [];
  transactionDetails: WorkshopTransactionDetails[] = [];
  paymentDetailModal: boolean = false;
  regName: string = "";
  phoneNumber: number = 0;
  totalPaypalAmount: number = 0;
  bookedTicketsCount: number = 0;
  eventId: number = 0;
  participantBookingCount: number = 0 ;
  eventDetails: EventBookingDetails[] = [];

  constructor(
    private appService: AppService, private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private aesService: AesEncryptionService
  ) {

  }
  ngOnInit(): void {
    this.eventDetailsGetAll();
  }

  eventDetailsGetAll() {
    this.spinner.show();
    this.appService.eventDetailsGetAll()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        const today = new Date().setHours(0, 0, 0, 0);
        const sorted = data
          .sort((a, b) => {
            const aIsFuture = a.startDate >= today;
            const bIsFuture = b.startDate >= today;
            if (aIsFuture && !bIsFuture) return -1;
            if (!aIsFuture && bIsFuture) return 1;
            return a.startDate - b.startDate;
          });
        this.eventDetails = sorted;
        this.spinner.hide();
      }, (error: any) => {
        this.spinner.hide()
        this.toastr.error(error?.error?.message || "Something Went Wrong, Please Try Again")
      });
  }

showThankYouMail(event: EventBookingDetails): boolean {
  if (!event || !event.startDate || !event.startTime) return false;
  return this.isRegistrationClosed(event);
}


  isRegistrationClosed(event: any): boolean {
    const now = Date.now();

    // Convert epoch startDate to real Date object
    const startDate = new Date(event.startDate);

    // Validate time string
    if (!event.startTime || !event.startTime.includes(' ')) return false;

    const [timePart, meridian] = event.startTime.trim().split(' ');
    let [hours, minutes] = timePart.split('.').map(Number);

    if (isNaN(hours)) return false;
    minutes = isNaN(minutes) ? 0 : minutes;

    // Convert to 24-hour format
    if (meridian.toUpperCase() === 'PM' && hours < 12) hours += 12;
    if (meridian.toUpperCase() === 'AM' && hours === 12) hours = 0;

    // Set hours/minutes on startDate
    startDate.setHours(hours, minutes, 0, 0);

    // Now compare
    return now > startDate.getTime();
  }

  formattedDate(epoch: number): string {
  const date = new Date(epoch);
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
}


  getEventIdWorkshopDetails(eventId: number) {
    this.spinner.show();
    this.appService.getEventIdWorkshopDetails(eventId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        const sorted = data.sort((a, b) => b.workshopId - a.workshopId);
        this.getListOfWorkshopDetails = sorted;
        const totalAudience = this.getListOfWorkshopDetails
        .reduce((sum, item) => sum + (item.audienceDetails?.length || 0), 0)
        this.participantBookingCount = totalAudience
        this.spinner.hide();
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.error.message || "Something Went Wrong,Please Try Again....")
      })
  }

  selectValue(event: any) {
    this.totalPaypalAmount = 0;
    this.bookedTicketsCount = 0;
    this.spinner.show();
    const eventId = +event.target.value;
    this.eventId = Number(eventId);
    this.getEventIdWorkshopDetails(this.eventId)
    this.spinner.hide();
  }

  paymentDetailView(details: any) {
    this.paymentDetailModal = true;
    this.transactionDetails = details.transactionDetails;
    this.regName = details?.studentName;
    this.phoneNumber = details?.phoneNumber
  }

  getSubParticipantsNames(audience: any[]): string {
  if (!audience || audience.length <= 1) {
    return "-"; // No sub participants
  }

  // Skip the first participant and return others
  const subNames = audience.slice(1).map(a => a.participantName);

  return subNames.join(", "); // join with comma
}

getTicketUrl(ticketSeq: string) {
  const encrypted = this.aesService.encrypt(ticketSeq);
  const encoded = encodeURIComponent(encrypted);

  return `https://ticket.cktechsoln.in/index.html?ticketNo=${encoded}`;
}



  getPaymentStatus(transactions: any) {
    if (!transactions || !Array.isArray(transactions)) {
      return 'ON ERROR';
    }

    const hasCompleted = transactions.some(t => t.status === 'COMPLETED');
    return hasCompleted ? 'COMPLETED' : 'ON ERROR';
  }

  generateExcelSheet() :void {
  if (!this.getListOfWorkshopDetails?.length) {
    this.toastr.error("No data found to download!");
    return;
  }

  // 1. Prepare Data (No changes here)
  const excelData = this.getListOfWorkshopDetails.map((item, index) => {
    const participants = item.audienceDetails || [];
    const ticketNosArr = participants.map(p => p.ticketNo || '-');
    const namesArr = participants.map(p =>
      p.participantName != null ? String(p.participantName) : '-'
    ).filter(Boolean);
    const attendanceStatus = participants.map(p =>
      p.attendanceStatus != null ? String(p.attendanceStatus) : '-'
    ).filter(Boolean);
    return {
      'S.No': index + 1,
      'Ticket No': item?.audienceDetails[0]?.ticketSeq,
      'Participant Names': namesArr.join('\n'),
      'Phone Number': item?.phoneNumber || '-',
      'Email': item?.emailId || '-',
      'Address' :  item?.address || '-',
      'Registered Date': item.createdAt ? new Date(item.createdAt).toLocaleDateString() : '-',
      'Participant Count': item.audienceDetails.length ?? 0,
      "Checking Status" : attendanceStatus.join('\n')
    };
  });

  // 2. Create Worksheet
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

  // 3. Define Styles
  const headerStyle = {
    font: { bold: true },
    fill: { patternType: 'solid', fgColor: { rgb: 'FFFF00' } }, // Yellow
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
  };

  const defaultCenterStyle = {
    alignment: {
      wrapText: true,
      vertical: 'center',
      horizontal: 'center',
    },
  };

  // * UPDATED *: Style for the 'Total Amount' column, now right-aligned
  const amountRightStyle = {
    alignment: {
      wrapText: true,
      vertical: 'center',
      horizontal: 'right', // Aligned to the right
    },
  };

  // 4. Set Column Widths and Row Heights
  ws['!cols'] = [
    { wch: 6 }, { wch: 20 }, { wch: 30 }, { wch: 10 }, { wch: 15 },
    { wch: 35 }, { wch: 35 }, { wch: 25 }, { wch: 25 }, { wch: 15 },
    { wch: 16 }, { wch: 15 }, { wch: 15 },
  ];

  // * UPDATED *: Increased row heights for better visibility
  const rowHeights = excelData.map(row => {
    const lines = (String(row['Participant Names']).match(/\n/g) || []).length + 1;
    return { hpx: Math.max(20, lines * 25) }; // Increased multiplier to 25
  });
  ws['!rows'] = [{ hpx: 30 }, ...rowHeights]; // Increased header height to 30

  // 5. Apply Styles to Cells
  const range = XLSX.utils.decode_range(ws['!ref']!);
  for (let c = range.s.c; c <= range.e.c; ++c) {
    const headerAddress = XLSX.utils.encode_cell({ r: 0, c });
    if (ws[headerAddress]) ws[headerAddress].s = headerStyle;

    for (let r = range.s.r + 1; r <= range.e.r; ++r) {
      const cellAddress = XLSX.utils.encode_cell({ r, c });
      const cell = ws[cellAddress];
      if (!cell) continue;

      const headerName = ws[XLSX.utils.encode_cell({ r: 0, c })]?.v;

      if (headerName === 'Total Amount') {
        cell.s = amountRightStyle; // Use right-align style
      } else {
        cell.s = defaultCenterStyle; // Use center-align for all others
      }
    }
  }

  // 6. Generate and Save File
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Registrations');
  const wbout: ArrayBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'RegistrationData.xlsx');
}
  
}
